import React from 'react'
import { Link } from 'react-router-dom'

export default function Home(){


    return(
        <>
        
            <header>
                <h1>Logo</h1>
                <ul>
                    <li> <strong> <Link to='/register'>Register</Link>  </strong></li>
                    <li><strong> <Link to='/login'>Login</Link> </strong></li>
                </ul>
            </header>
            <section className='section'>
                <h1>BEM VINDO</h1>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                </p>
                <p>
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.
                </p>
            </section>
        
        </>
    )
}